/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppConversationIndex } from '../../axios/whatsAppConversationIndex'
import type {
	WhatsAppConversationIndexError,
	WhatsAppConversationIndexResponse,
} from '../../types/WhatsAppConversationIndex'

export const whatsAppConversationIndexQueryKey = () => [{ url: '/whatsapp/conversations' }] as const

export type WhatsAppConversationIndexQueryKey = ReturnType<typeof whatsAppConversationIndexQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppConversationController.php WhatsAppConversationController::index */
export function whatsAppConversationIndexQueryOptions(config?: AxiosRequestConfig) {
	return queryOptions<
		WhatsAppConversationIndexResponse,
		AxiosError<WhatsAppConversationIndexError>,
		WhatsAppConversationIndexResponse,
		WhatsAppConversationIndexQueryKey
	>({
		queryKey: whatsAppConversationIndexQueryKey(),
		queryFn: ({ signal }) => whatsAppConversationIndex({ signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppConversationController.php WhatsAppConversationController::index */
export function useWhatsAppConversationIndex<TSelectData = WhatsAppConversationIndexResponse>(
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					WhatsAppConversationIndexResponse,
					AxiosError<WhatsAppConversationIndexError>,
					TSelectData,
					WhatsAppConversationIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<WhatsAppConversationIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...whatsAppConversationIndexQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppConversationController.php WhatsAppConversationController::index */
export function useWhatsAppConversationIndexSuspense<TSelectData = WhatsAppConversationIndexResponse>(
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					WhatsAppConversationIndexResponse,
					AxiosError<WhatsAppConversationIndexError>,
					TSelectData,
					WhatsAppConversationIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<WhatsAppConversationIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...whatsAppConversationIndexQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
